export const LOCAL_STORAGE_MENTOR_CLOUD_VIEW = 'mentorCloudView'
export const LOCAL_STORAGE_MENTOR_CLOUD_FOLDER_SORT = 'mentorCloudFolderSort'
export const LOCAL_STORAGE_MENTOR_CLOUD_FILE_SORT = 'mentorCloudFileSort'